/**
 * training-form.js
 *
 * Standalone helper for the training pages (/training/) across all sites.
 * When a training card button carrying `data-training="<exact dropdown value>"`
 * is clicked, it preselects that training in the contact-form dropdown and
 * focuses the first-name field so the user can start typing immediately.
 *
 * The existing `data-scroll="contact"` handler (in main.js) still performs the
 * smooth scroll to the form — this script only sets the dropdown + focus.
 *
 * Compiled to its own bundle (shared-meta2/dist/js/training-form[.min].js) and
 * linked only on training pages — it is intentionally NOT part of bundle.js.
 */
(function () {
  "use strict";

  function init() {
    var triggers = document.querySelectorAll("[data-training]");
    if (!triggers.length) return;

    // Find the training <select> in the contact form by matching an option value
    // (avoids relying on the server-generated ClientID).
    function findTrainingSelect(value) {
      var selects = document.querySelectorAll("#contact select");
      for (var i = 0; i < selects.length; i++) {
        var opts = selects[i].options;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j].value === value) return selects[i];
        }
      }
      return null;
    }

    triggers.forEach(function (el) {
      el.addEventListener("click", function () {
        var value = el.getAttribute("data-training");
        var sel = findTrainingSelect(value);
        if (sel) {
          sel.value = value;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // Focus the first-name field so the user can start typing immediately.
        // preventScroll keeps the smooth-scroll to #contact from being interrupted.
        var firstName = document.querySelector("#contact .form-control");
        if (firstName) {
          try {
            firstName.focus({ preventScroll: true });
          } catch (e) {
            firstName.focus();
          }
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
